var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "applyUnbind" } },
    [
      _c(
        "el-form",
        {
          ref: "applyUnbindForm",
          staticClass: "applyUnbindForm",
          attrs: {
            model: _vm.applyUnbindForm,
            rules: _vm.rules,
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "解绑店铺", prop: "mallCode" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  on: { change: _vm.changeMall },
                  model: {
                    value: _vm.applyUnbindForm.mallCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.applyUnbindForm, "mallCode", $$v)
                    },
                    expression: "applyUnbindForm.mallCode",
                  },
                },
                _vm._l(_vm.mallList, function (item) {
                  return _c(
                    "el-option",
                    {
                      key: item.mallCode,
                      attrs: { label: item.mallName, value: item.mallCode },
                    },
                    [
                      _c("span", { staticClass: "y-f y-f-a" }, [
                        _c("img", {
                          staticClass: "iconstyle",
                          attrs: {
                            src: require(`@/assets/images/ecommercepng/icon_dianpu_${item.platformCode}.png`),
                            alt: "",
                          },
                        }),
                        _vm._v(" " + _vm._s(item.mallName) + " "),
                      ]),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "原收款人姓名", prop: "alipayRealName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入", disabled: "" },
                model: {
                  value: _vm.applyUnbindForm.alipayRealName,
                  callback: function ($$v) {
                    _vm.$set(_vm.applyUnbindForm, "alipayRealName", $$v)
                  },
                  expression: "applyUnbindForm.alipayRealName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "合作网点", prop: "branchCode" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    remote: "",
                    placeholder: "请输入网点名称或编号",
                    "remote-method": _vm.remoteMethod,
                    loading: _vm.loading,
                  },
                  on: { focus: _vm.clearOptionList },
                  model: {
                    value: _vm.applyUnbindForm.branchCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.applyUnbindForm, "branchCode", $$v)
                    },
                    expression: "applyUnbindForm.branchCode",
                  },
                },
                _vm._l(_vm.optionList, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.orgName, value: item.orgCode },
                  })
                }),
                1
              ),
              _c(
                "el-tooltip",
                {
                  staticClass: "tooltip-style",
                  attrs: { effect: "light", placement: "right-start" },
                },
                [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _c("span", { staticStyle: { color: "#666666" } }, [
                      _vm._v(
                        "合作网点请选择您授权店铺合作网点，将由合作网点审核解绑"
                      ),
                    ]),
                  ]),
                  _c(
                    "span",
                    { staticClass: "helpInfo setting-btn y-c-p y-ml-5" },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/images/icon_tips@2x.png"),
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "联系电话", prop: "relationTelephone" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入" },
                model: {
                  value: _vm.applyUnbindForm.relationTelephone,
                  callback: function ($$v) {
                    _vm.$set(_vm.applyUnbindForm, "relationTelephone", $$v)
                  },
                  expression: "applyUnbindForm.relationTelephone",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "申请说明", prop: "applyReason" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 3 },
                  placeholder: "请输入",
                  maxlength: "300",
                },
                model: {
                  value: _vm.applyUnbindForm.applyReason,
                  callback: function ($$v) {
                    _vm.$set(_vm.applyUnbindForm, "applyReason", $$v)
                  },
                  expression: "applyUnbindForm.applyReason",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "图片" } },
            [
              _c(
                "el-upload",
                {
                  ref: "upload",
                  staticClass: "uploadImg",
                  class: { hide: _vm.showUpload },
                  attrs: {
                    action: "/steward/web/workOrder/uploadWorkOrderImg",
                    "list-type": "picture-card",
                    limit: 5,
                    accept: ".jpg,.jpeg,.png,.gif",
                    "on-exceed": _vm.handleExceed,
                    headers: _vm.headers,
                    "before-upload": _vm.beforeAvatarUpload,
                    "on-success": _vm.uploadSuccess,
                    "on-preview": _vm.handlePictureCardPreview,
                    "on-remove": _vm.handleRemove,
                  },
                },
                [_c("i", { staticClass: "el-icon-plus" }, [_vm._v("上传照片")])]
              ),
              [
                !_vm.showUpload
                  ? _c("div", {
                      attrs: { id: "tar_box", contenteditable: "" },
                      on: { input: _vm.focusTarBox },
                    })
                  : _vm._e(),
                _vm.imgError
                  ? _c(
                      "div",
                      { staticClass: "el-form-item__error uploadImg_error" },
                      [_vm._v("图片不能为空")]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "el-upload__tip" }, [
                  _vm._v(
                    "支持jpg、jpeg、gif、png格式的图片，最多上传5张，单张图片大小不超过5M，支持复制粘贴上传"
                  ),
                ]),
              ],
            ],
            2
          ),
          _c(
            "el-form-item",
            { staticClass: "form-btn", attrs: { "label-width": "0" } },
            [
              _c(
                "el-button",
                { staticClass: "y-w-100", on: { click: _vm.close } },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "y-w-100",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.applyUnbind("applyUnbindForm")
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "append-to-body": "",
            close: "img-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }